import React, { Component } from 'react'
import { Card, CardContent, Typography } from '@material-ui/core'
import { COLORES } from '../../../../config/colores'
import { Link } from 'react-router-dom'

class AccesoPreingresoCalado extends Component {
  render () {
    return (
      <div>
        <h3>Accesos a preingreso calado</h3>
        <div className='container-card-accesos-preingreso'>
          <Link to='/preingresoCalado/1-2' className='card-acceso-preingreso'>
            <Card>
              <CardContent style={{ padding: '0 0 0 0' }}>
                <Typography style={{ textAlign: 'center', padding: '4px 0', fontSize: '20px', fontWeight: '150', color: '#ffffff', backgroundColor: COLORES.blue.primary }}>
                                Preingreso
                </Typography>
                <Typography variant='h5' style={{ padding: '25px 0', color: '#495057' }}>
                                Calles 1 y 2
                </Typography>
              </CardContent>
            </Card>
          </Link>

          <Link to='/preingresoCalado/3-4' className='card-acceso-preingreso'>
            <Card>
              <CardContent style={{ padding: '0 0 0 0' }}>
                <Typography style={{ textAlign: 'center', padding: '4px 0', fontSize: '20px', fontWeight: '150', color: '#ffffff', backgroundColor: COLORES.blue.primary }}>
                                Preingreso
                </Typography>
                <Typography variant='h5' style={{ padding: '25px 0', color: '#495057' }}>
                        Calles 3 y 4
                </Typography>
              </CardContent>
            </Card>
          </Link>
        </div>
      </div>
    )
  }
}

export default AccesoPreingresoCalado
